import { Box, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@material-ui/core";
import Highcharts from "highcharts";
import { useParams } from "react-router-dom";
import ExternalLinkButton from "src/components/Button/ExternalLinkButton";
import TitleTypography from "src/components/Typography/TitleTypography";
import { EXPLORER_TYPE } from "src/hooks/useExplorerUrl";
import { formatAddress, numberWithCommas, toFixed } from "src/services/utils";

const LiquidateLinkTooltip = ({ text, hash, config }) => {
  return (
    <Box display="flex" justifyContent="flex-start" alignItems="center">
      <Typography>{text}</Typography>
      <ExternalLinkButton {...{ hash, config }} />
    </Box>
  );
};

export default function LiquidationHistoryTable({ timestamp, data }) {
  const { pool } = useParams();

  return data ? (
    <TableContainer>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography color="textSecondary">Transaction hash</Typography>
            </TableCell>
            <TableCell>
              <LiquidateLinkTooltip
                config={{ pool, type: EXPLORER_TYPE.TRANSACTION }}
                hash={data.tx_hash}
                text={formatAddress(data.tx_hash, 6)}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography color="textSecondary">Liquidator</Typography>
            </TableCell>
            <TableCell>
              <LiquidateLinkTooltip config={{ pool }} hash={data.liquidator} text={formatAddress(data.liquidator, 6)} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography color="textSecondary">Collateral Asset</Typography>
            </TableCell>
            <TableCell>
              <LiquidateLinkTooltip config={{ pool }} hash={data.collateral_asset} text={data.symbol_collateral} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography color="textSecondary">Liquidated Collateral Amount</Typography>
            </TableCell>
            <TableCell>
              <Typography>{numberWithCommas(toFixed(data.liquidated_collateral_amount, 2))}</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography color="textSecondary">Debt Asset</Typography>
            </TableCell>
            <TableCell>
              <LiquidateLinkTooltip config={{ pool }} hash={data.debt_asset} text={data.symbol_debt} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography color="textSecondary">Debt to Cover</Typography>
            </TableCell>
            <TableCell>
              <Typography>{numberWithCommas(toFixed(data.debt_to_cover, 2))}</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography color="textSecondary">Date Time</Typography>
            </TableCell>
            <TableCell>
              <Typography>{Highcharts.dateFormat("%b %e, %Y, %k:%M", timestamp * 1000)}</Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <Box display="flex" justifyContent="center" alignItems="center" height="100%" mt={2}>
      <TitleTypography textProps={{ variant: "h4" }} title="Click on chart to see data" />
    </Box>
  );
}
